import styled from 'styled-components';
import { config } from '../../../Configurations';

// Column container
export const ColumnProfileContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

// Row container
export const RowProfileContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

export const LeftContainer = styled.div`
    background-image: ${props => `url(${config.baseUrl}/${props.background})`};
    height: 100vh;
    width: 30vw;
    background-size: cover;
    background-position: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
`;

export const LeftContent = styled.div`
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000 94%);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const RightContainer = styled.div`
    width: 70vw;
    margin-left: 30vw;

    display: flex;
    flex-direction: column;
    align-items: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/ProfilePageWrapper/style.js